export default __webpack_public_path__ + "static/media/cli-saint.88f9848c.jpg";